import { jsx as _jsx } from "react/jsx-runtime";
import { MsalProvider } from '@azure/msal-react';
import React from 'react';
// eslint-disable-next-line import/no-internal-modules
import ReactDOM from 'react-dom/client';
import { msalInstance } from '.';
import { AuthenticationBoundary, UserContextProvider } from '..';
import { RuntimeContext } from '../../shell';
import { Shell } from '../types';
import { initializeRuntime } from '../../init/initializeRuntime';
export function render(children, shell = Shell.Business, runtime, hasAuthentication = true) {
    const root = ReactDOM.createRoot(document.getElementById('root'));
    root.render(_jsx(React.StrictMode, { children: _jsx(RuntimeContext.Provider, { value: runtime, children: _jsx(UserContextProvider, { children: shell === Shell.Business && hasAuthentication ? (_jsx(AuthenticationBoundary, { children: children })) : (_jsx(MsalProvider, { instance: msalInstance, children: children })) }) }) }));
}
export async function renderRoot({ children, remotes, register, registerNav, shell = Shell.Business, hasAuthentication = true, loggers = null, name, useAuthorizationOrganizationFakes = false, }) {
    let runtime;
    runtime = await initializeRuntime({
        shell,
        register,
        registerNav,
        remotes,
        loggers,
        name,
        useAuthorizationOrganizationFakes,
    });
    render(children, shell, runtime, hasAuthentication);
}
